import React, { useState, useEffect } from "react";
import { Route, Switch, withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

// Components
import Sidebar from "../../Container/Sidebar";
import Home from "../../Components/Dashboard/home";
import Product from "../../Components/Dashboard/product";
import Themes from "../../Components/Dashboard/themes";
import Users from "../../Components/Dashboard/users";
import ZipCodes from "../../Components/Dashboard/zip";
import Videos from "../../Components/Dashboard/videos";
import ContactUs from "../../Components/Dashboard/contact-us";
import Help from "../../Components/Dashboard/help";
import Services from "../../Components/Dashboard/services";
import Questions from "../../Components/Dashboard/questions";
import ServiceRequest from "../../Components/Dashboard/service-request";
import Settings from "../../Components/Dashboard/settings";
import Admin from "../Dashboard/admin";
import Banks from "../../Components/Dashboard/banks";
import MobileConfiguration from "../../Components/Dashboard/mobile-configuration";
import Signup from "./signup";
import ChangePassword from "../../Components/Dashboard/change-password";
import Header from "../../Container/Header";
import PrivateRoute from "../../PrivateRoute";
import Holidays from "../../Components/Dashboard/holidays";
import Announcements from "../../Components/Dashboard/announcements";

// style
import HomeStyle from "./style";
import SmartSafeReconciliations from "./SmartSafeReconciliations.js";
import DepositRecords from "./DepositRecords.js";
import SafeManagement from "./SafeManagement.js";

function Dashboard(props) {
	const [bankListData, setBankListData] = useState(() => []);
	//TODO Remove?
	//const [holidaysListData, setHolidaysListData] = useState(() => []);
	//const [annoucementListData, setAnnouncementListData] = useState(() => []);
	const [response, setResponse] = useState("");
	const [collapse, setCollapse] = useState("");
	const [userItem, setUserItem] = useState("");
	const [status, setStatus] = useState("");
	const [Search, SetSearch] = useState("");
	const [fileInfo, SetFileInfo] = useState("");
	const [enabledCount, SetEnabledCount] = useState("");
	const [disabledCount, SetDisabledCount] = useState("");
	const [clear, setClear] = useState("");
	const [reloadBanks, setReloadBanks] = useState(false);
	const [total, setTotal] = useState("");
	const NoFound = () => {
		return <Redirect to="/PageNotFound" />;
	};

	const handleSearch = (search) => {
		SetSearch(search);
	};

	useEffect(() => {
		SetSearch("");
	}, [clear]);

	useEffect(() => {
		getBankList();
	}, [clear, reloadBanks]);

	const handleResp = (type) => {
		if (type.response && type.response.message) {
			if (type.response.status === 200) {
				toast.success(`${type.response.message}`);
			} else {
				toast.error(`${type.response.message}`);
			}
		}
	};

	const getBankList = async () => {
		const res = await axios.get(
			`${process.env.REACT_APP_API_URL}api/admin/banklist`,
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
			},
		);
		if (res.status === 200 && res.data && res.data.data) {
			const list = res.data.data;
			const data = list.map((data) => ({ label: data.name, value: data.id }));
			setBankListData(data);
		}
	};

	const handleRespUpload = (type) => {
		if (type) {
			if (type.status === 200) {
				toast.success(`${type.message}`);
			} else {
				toast.error(`${type.message}`);
			}
		}
	};

	const handleRespHelp = (type) => {
		if (type.response && type.response.message) {
			if (type.response.status === 200) {
				toast.success(`${type.response.message}`);
			} else {
				toast.error(`${type.response.message}`);
			}
		}
	};

	//Don't want to show header  if we are adding / editing full screen
	const showHeader = () => {
		if (props.location.pathname === "/dashboard") return false;
		else {
			return (
				props.location.pathname.split("/")[3] !== "add-theme" &&
				props.location.pathname.split("/")[3] !== "edit-theme" &&
				props.location.pathname.split("/")[3] !== "add-services" &&
				props.location.pathname.split("/")[3] !== "edit-services" &&
				props.location.pathname.split("/")[3] !== "add-questions" &&
				props.location.pathname.split("/")[3] !== "edit-questions" &&
				props.location.pathname.split("/")[3] !== "add-admin" &&
				props.location.pathname.split("/")[3] !== "edit-admin" &&
				props.location.pathname.split("/")[3] !== "add-settings" &&
				props.location.pathname.split("/")[3] !== "edit-settings" &&
				props.location.pathname.split("/")[3] !== "add-help" &&
				props.location.pathname.split("/")[3] !== "edit-help"
			);
		}
	};

	return (
		<div className="d-flex">
			<Sidebar collpase={(e) => setCollapse(e)} bankListData={bankListData} />
			<div
				className="bg-black"
				style={!collapse ? { width: "83%" } : { width: "93%" }}
			>
				{showHeader() && (
					<Header
						search={(search) => handleSearch(search)}
						userSelected={(item) => setUserItem(item)}
						statusSelected={(item) => setStatus(item)}
						Upload={(e, fileInfo) => SetFileInfo(fileInfo)}
						disabled={disabledCount}
						enabled={enabledCount}
						clear={clear}
						total={total}
					/>
				)}
				{sessionStorage.getItem("userDetails") && (
					<Switch>
						{JSON.parse(sessionStorage.getItem("userDetails"))[0].user_roles[0]
							.role_id === 4 ? (
							JSON.parse(
								sessionStorage.getItem("userDetails"),
							)[0].user_permissions.map((item, index) => {
								return (
									item.status === 1 && (
										<PrivateRoute
											key={index}
											exact={
												item.module_id === 1 ||
												item.module_id === 2 ||
												item.module_id === 4 ||
												item.module_id === 5 ||
												item.module_id === 6 ||
												item.module_id === 7 ||
												item.module_id === 10 ||
												item.module_id === 13 ||
												item.module_id === 15 ||
												item.module_id === 17 ||
												item.module_id === 19
											}
											path={
												(item.module_id === 1 && "/dashboard/home") ||
												(item.module_id === 2 && "/dashboard/product") ||
												(item.module_id === 3 && "/dashboard/themes") ||
												(item.module_id === 4 && "/dashboard/users") ||
												(item.module_id === 5 && "/dashboard/zipcodes") ||
												(item.module_id === 6 && "/dashboard/videos") ||
												(item.module_id === 7 && "/dashboard/contact-us") ||
												(item.module_id === 8 && "/dashboard/services") ||
												(item.module_id === 9 && "/dashboard/questions") ||
												(item.module_id === 10 &&
													"/dashboard/service-request") ||
												(item.module_id === 11 && "/dashboard/settings") ||
												(item.module_id === 12 && "/dashboard/help") ||
												(item.module_id === 13 &&
													"/dashboard/mobile-configuration") ||
												(item.module_id === 14 && "/dashboard/signup") ||
												(item.module_id === 15 && "/dashboard/announcements") ||
												(item.module_id === 17 && "/dashboard/banks") ||
												(item.module_id === 19 && "/dashboard/safes")
											}
										>
											{/* Show these for non-super admins */}
											{item.module_id === 1 && (
												<Home
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													userData={userItem}
													status={status}
													Search={Search}
												/>
											)}
											{item.module_id === 2 && (
												<Product
													clear={(clear) => setClear(clear)}
													Search={Search}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													userData={userItem}
													status={status}
												/>
											)}
											{item.module_id === 3 && (
												<Themes
													respType={(e) => handleResp(e)}
													clear={(clear) => setClear(clear)}
													status={status}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													Search={Search}
												/>
											)}
											{item.module_id === 4 && (
												<Users
													UploadResp={(e) => handleRespUpload(e)}
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													fileInfo={fileInfo}
													search={Search}
													userData={userItem}
													status={status}
												/>
											)}
											{item.module_id === 5 && (
												<ZipCodes
													UploadResp={(e) => handleRespUpload(e)}
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													fileInfo={fileInfo}
													disabled={(count) => SetDisabledCount(count)}
													search={Search}
													status={status}
												/>
											)}
											{item.module_id === 6 && (
												<Videos
													clear={(clear) => setClear(clear)}
													Search={Search}
													status={status}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
												/>
											)}
											{item.module_id === 7 && (
												<ContactUs
													clear={(clear) => setClear(clear)}
													Search={Search}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
												/>
											)}
											{item.module_id === 8 && (
												<Services
													respType={(e) => handleResp(e)}
													userData={userItem}
													status={status}
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													Search={Search}
												/>
											)}
											{item.module_id === 9 && (
												<Questions
													UploadResp={(e) => handleRespUpload(e)}
													respType={(e) => handleResp(e)}
													status={status}
													fileInfo={fileInfo}
													clear={(clear) => setClear(clear)}
													Search={Search}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
												/>
											)}
											{item.module_id === 10 && (
												<ServiceRequest
													total={(total) => setTotal(total)}
													clear={(clear) => setClear(clear)}
													search={Search}
												/>
											)}
											{item.module_id === 11 && (
												<Settings
													respType={(e) => handleResp(e)}
													userData={userItem}
													status={status}
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													Search={Search}
												/>
											)}
											{item.module_id === 12 && (
												<Help
													respType={(e) => handleRespHelp(e)}
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													Search={Search}
												/>
											)}
											{item.module_id === 13 && <MobileConfiguration />}
											{item.module_id === 14 && <Signup />}
											{item.module_id === 15 && (
												<Announcements
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													search={Search}
													userData={userItem}
													status={status}
												/>
											)}
											{item.module_id === 17 && (
												<Banks
													clear={(clear) => setClear(clear)}
													enabled={(count) => SetEnabledCount(count)}
													disabled={(count) => SetDisabledCount(count)}
													search={Search}
													userData={userItem}
													status={status}
													reload={() => getBankList()}
												/>
											)}
											{item.module_id === 19 && (
												<SafeManagement style={{ overflowY: "scroll" }} />
											)}

											{item.module_id === 20 && (
												<Switch>
													<PrivateRoute
														exact
														path="/dashboard/reconciliations/smart-safe"
													>
														<SmartSafeReconciliations
															style={{ overflowY: "scroll" }}
														/>
													</PrivateRoute>

													<PrivateRoute
														exact
														path="/dashboard/reconciliations/safe-deposits"
													>
														<DepositRecords style={{ overflowY: "scroll" }} />
													</PrivateRoute>

													{/* Optional: default landing under /reconciliations */}
													<Redirect
														exact
														from="/dashboard/reconciliations"
														to="/dashboard/reconciliations/smart-safe"
													/>
												</Switch>
											)}
										</PrivateRoute>
									)
								);
							})
						) : (
							<>
								{/* Or Show these for super admins */}
								<PrivateRoute exact path="/dashboard/home">
									<Home
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										userData={userItem}
										status={status}
										Search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/product">
									<Product
										clear={(clear) => setClear(clear)}
										Search={Search}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										userData={userItem}
										status={status}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/themes">
									<Themes
										respType={(e) => handleResp(e)}
										clear={(clear) => setClear(clear)}
										status={status}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										Search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/help">
									<Help
										respType={(e) => handleResp(e)}
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										Search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/users">
									<Users
										UploadResp={(e) => handleRespUpload(e)}
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										fileInfo={fileInfo}
										search={Search}
										userData={userItem}
										status={status}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/zipcodes">
									<ZipCodes
										UploadResp={(e) => handleRespUpload(e)}
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										fileInfo={fileInfo}
										disabled={(count) => SetDisabledCount(count)}
										search={Search}
										status={status}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/videos">
									<Videos
										clear={(clear) => setClear(clear)}
										Search={Search}
										status={status}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/contact-us">
									<ContactUs
										clear={(clear) => setClear(clear)}
										Search={Search}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/questions">
									<Questions
										UploadResp={(e) => handleRespUpload(e)}
										respType={(e) => handleResp(e)}
										status={status}
										fileInfo={fileInfo}
										clear={(clear) => setClear(clear)}
										Search={Search}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/services">
									<Services
										respType={(e) => handleResp(e)}
										userData={userItem}
										status={status}
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										Search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/service-request">
									<ServiceRequest
										total={(total) => setTotal(total)}
										clear={(clear) => setClear(clear)}
										search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/settings">
									<Settings
										respType={(e) => handleResp(e)}
										userData={userItem}
										status={status}
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										Search={Search}
									/>
								</PrivateRoute>
								<PrivateRoute path="/dashboard/admin">
									<Admin
										clear={(clear) => setClear(clear)}
										respType={(e) => handleResp(e)}
										Search={Search}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/banks">
									<Banks
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										search={Search}
										userData={userItem}
										status={status}
										reload={() => getBankList()}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/holidays">
									<Holidays
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										search={Search}
										userData={userItem}
										status={status}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/announcements">
									<Announcements
										clear={(clear) => setClear(clear)}
										enabled={(count) => SetEnabledCount(count)}
										disabled={(count) => SetDisabledCount(count)}
										search={Search}
										userData={userItem}
										status={status}
									/>
								</PrivateRoute>
								<PrivateRoute exact path="/dashboard/safes">
									<SafeManagement style={{ overflowY: "scroll" }} />
								</PrivateRoute>
								<PrivateRoute
									exact
									path="/dashboard/reconciliations/smart-safe"
								>
									<SmartSafeReconciliations style={{ overflowY: "scroll" }} />
								</PrivateRoute>
								<PrivateRoute
									exact
									path="/dashboard/reconciliations/safe-deposits"
								>
									<DepositRecords style={{ overflowY: "scroll" }} />
								</PrivateRoute>
								<PrivateRoute
									exact
									path="/dashboard/mobile-configuration"
									component={MobileConfiguration}
								/>
								<PrivateRoute
									exact
									path="/dashboard/change-password"
									component={ChangePassword}
								/>
								<PrivateRoute
									exact
									path="/dashboard/signup"
									component={Signup}
								/>
							</>
						)}
						<PrivateRoute
							exact
							path="/dashboard/change-password"
							component={ChangePassword}
						/>
						<Route
							render={({ location }) => {
								console.log(`Attempted route: ${location.pathname}`);
								return <NoFound />;
							}}
						/>
					</Switch>
				)}
			</div>
			<HomeStyle />
			<ToastContainer closeButton={false} position="top-center" />
		</div>
	);
}

export default withRouter(Dashboard);
